import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d3f87c6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "smainheadern col-11" }
const _hoisted_2 = { class: "d-flex align-items-start justify-content-start col-12" }
const _hoisted_3 = { class: "stextarea col-12" }
const _hoisted_4 = { class: "shtextholder" }
const _hoisted_5 = { class: "stitle" }
const _hoisted_6 = { class: "shtext" }
const _hoisted_7 = { class: "hscontent" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "40",
    height: "40",
    rx: "20",
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 0 40)",
    class: "prevarrow",
    fill: "#75AE3D"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M22.9828 13.6884C23.4501 14.1618 23.4501 14.9292 22.9828 15.4026L18.4443 20L22.9828 24.5975C23.4501 25.0709 23.4501 25.8383 22.9828 26.3117C22.5155 26.785 21.7579 26.785 21.2906 26.3117L15.9059 20.8571C15.4387 20.3838 15.4387 19.6163 15.9059 19.1429L21.2906 13.6884C21.7579 13.215 22.5155 13.215 22.9828 13.6884Z",
    fill: "#161616"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "40",
    height: "40",
    rx: "20",
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 0 40)",
    class: "nextarrow",
    fill: "#75AE3D"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.0172 26.3116C16.5499 25.8382 16.5499 25.0708 17.0172 24.5974L21.5557 20L17.0172 15.4025C16.5499 14.9291 16.5499 14.1617 17.0172 13.6883C17.4845 13.215 18.2421 13.215 18.7094 13.6883L24.0941 19.1429C24.5614 19.6162 24.5614 20.3837 24.0941 20.8571L18.7094 26.3116C18.2421 26.785 17.4845 26.785 17.0172 26.3116Z",
    fill: "#161616"
  })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "scardholder" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center cardbody" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mcard d-md-flex" }, [
    /*#__PURE__*/_createElementVNode("div", null, "Gaming"),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "33",
        height: "21",
        viewBox: "0 0 33 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createElementVNode("rect", {
          x: "0.5",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#75AE3D"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12.5",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24.5",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "0.5",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12.5",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24.5",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mcard d-md-flex" }, [
    /*#__PURE__*/_createElementVNode("div", null, "Tech Art & 3D Modeling"),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "32",
        height: "21",
        viewBox: "0 0 32 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createElementVNode("rect", {
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#75AE3D"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mcard d-md-flex" }, [
    /*#__PURE__*/_createElementVNode("div", null, "Web & Software Development"),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "33",
        height: "21",
        viewBox: "0 0 33 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createElementVNode("rect", {
          x: "0.5",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12.5",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24.5",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#75AE3D"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "0.5",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12.5",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24.5",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mcard d-md-flex" }, [
    /*#__PURE__*/_createElementVNode("div", null, "Big Data & Analytics"),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "32",
        height: "21",
        viewBox: "0 0 32 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createElementVNode("rect", {
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#75AE3D"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mcard d-md-flex" }, [
    /*#__PURE__*/_createElementVNode("div", null, "AI & Data Science"),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "33",
        height: "21",
        viewBox: "0 0 33 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createElementVNode("rect", {
          x: "0.5",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12.5",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24.5",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "0.5",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12.5",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#75AE3D"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24.5",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mcard d-md-flex" }, [
    /*#__PURE__*/_createElementVNode("div", null, "Cloud Infrastructure & DevOps"),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "32",
        height: "21",
        viewBox: "0 0 32 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createElementVNode("rect", {
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#75AE3D"
        })
      ])
    ])
  ])
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center cardbody" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mcard d-md-flex" }, [
    /*#__PURE__*/_createElementVNode("div", null, "Telecommunication"),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "33",
        height: "21",
        viewBox: "0 0 33 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createElementVNode("rect", {
          x: "0.5",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#75AE3D"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12.5",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24.5",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "0.5",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12.5",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24.5",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mcard d-md-flex" }, [
    /*#__PURE__*/_createElementVNode("div", null, "Airspace Engineering"),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "32",
        height: "21",
        viewBox: "0 0 32 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createElementVNode("rect", {
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#75AE3D"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mcard d-md-flex" }, [
    /*#__PURE__*/_createElementVNode("div", null, "Bioengineering"),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "33",
        height: "21",
        viewBox: "0 0 33 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createElementVNode("rect", {
          x: "0.5",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12.5",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24.5",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#75AE3D"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "0.5",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12.5",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24.5",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mcard d-md-flex" }, [
    /*#__PURE__*/_createElementVNode("div", null, "Digital Marketing"),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "32",
        height: "21",
        viewBox: "0 0 32 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createElementVNode("rect", {
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#75AE3D"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mcard d-md-flex" }, [
    /*#__PURE__*/_createElementVNode("div", null, "Information Technology"),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "33",
        height: "21",
        viewBox: "0 0 33 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createElementVNode("rect", {
          x: "0.5",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12.5",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24.5",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "0.5",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12.5",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#75AE3D"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24.5",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mcard d-md-flex" }, [
    /*#__PURE__*/_createElementVNode("div", null, "Data Analytics"),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "32",
        height: "21",
        viewBox: "0 0 32 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createElementVNode("rect", {
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24",
          y: "0.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "12",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#F5F5F5"
        }),
        /*#__PURE__*/_createElementVNode("rect", {
          x: "24",
          y: "12.5",
          width: "8",
          height: "8",
          rx: "4",
          fill: "#75AE3D"
        })
      ])
    ])
  ])
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-custom-pagination-sheader py-2 d-flex justify-content-center" }, null, -1))

import { ref } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Autoplay } from 'swiper/modules';


import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';


export default /*#__PURE__*/_defineComponent({
  __name: 'MainSubHeader',
  props: {
	options: Object
},
  setup(__props) {

let modules = [Pagination, Autoplay];

const swiperInstance = ref();



const onSwiper = (swiper) => {
	swiperInstance.value = swiper;
	checkArrows();
};

const swiperNextSlide = () => {
	swiperInstance.value.slideNext();
	checkArrows();
};

const swiperPrevSlide = () => {
	swiperInstance.value.slidePrev();
	checkArrows();
};

const checkArrows = () => {
	document.querySelector(".prevarrow").classList.remove("disabled");
	document.querySelector(".nextarrow").classList.remove("disabled");
	if (swiperInstance.value.activeIndex === 0) {
		document.querySelector(".prevarrow").classList.add("disabled");
	} else if (swiperInstance.value.activeIndex === swiperInstance.value.slides.length - 1) {
		document.querySelector(".nextarrow").classList.add("disabled");
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('submainheader.subtitle', 'Industries We Specialize In')), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('submainheader.title', 'We provide expert global recruitment solutions across the most in-demand tech industries, matching top talent with companies worldwide.')), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", { class: "d-flex align-items-start w-100" }, [
            _createElementVNode("div", { class: "ms-auto" }, [
              _createElementVNode("div", { class: "d-flex justify-content-center gap-4" }, [
                _createElementVNode("div", {
                  role: "button",
                  onClick: swiperPrevSlide
                }, _hoisted_9),
                _createElementVNode("div", {
                  role: "button",
                  onClick: swiperNextSlide
                }, _hoisted_11)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(Swiper), {
              centeredSlides: false,
              xnitialSlide: "1",
              pagination: {  el: '.swiper-custom-pagination-sheader', clickable: true, type: 'bullets' },
              loop: false,
              grabCursor: true,
              slidesPerView: 'auto',
              xautoplay: { delay: 3000 },
              modules: _unref(modules),
              onSwiper: onSwiper,
              class: "w-100"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(SwiperSlide), null, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SwiperSlide), null, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modules"])
          ]),
          _hoisted_15
        ])
      ])
    ])
  ]))
}
}

})